require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-fleet-standard-sport.json") })
        }
      }, "path---es-fleet-standard-sport");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-fleet-standard-sport!./.cache/json/es-fleet-standard-sport.json
// module id = 1092
// module chunks = 231608221292675